import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'yesNo' })
export class YesNoBooleanPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return value ? "yes" : "no";
  }
}

